import { combineReducers } from 'redux'

import errorsReducer from './errors-reducer'
import forceScanReducer from './force-scan-reducer'
import manifestInfoReducer from './manifest-info-reducer'
import mobileAppsReducer from './mobile-apps-reducer'
import protectedPageReducer from './protected-page-reducer'
import quantifiedSitesReducer from './quantified-sites-reducer'
import siteInfoReducer from './site-info-reducer'
import userInfoReducer from './user-info-reducer'

export default combineReducers({
  errors: errorsReducer,
  forceScan: forceScanReducer,
  manifestInfo: manifestInfoReducer,
  mobileApps: mobileAppsReducer,
  quantifiedSites: quantifiedSitesReducer,
  protectedPage: protectedPageReducer,
  userInfo: userInfoReducer,
  siteInfo: siteInfoReducer
})



// WEBPACK FOOTER //
// ./src/reducers/app-reducer.js